<script>
export default {
  props: {
    title: {
      type: String,
      default: '小满装饰'
    },
    buttonText: {
      type: String,
      default: '立即获取报价'
    }
  },
  data() {
    return {
      phoneNumber: ''
    }
  },
  methods: {
    onClickQuotation() {
      if (this.phoneNumber.length !== 11) {
        this.$notify({
          message: '请输入正确的11位手机号',
          type: 'warning',
          duration: 3000
        })
      } else {
        this.$emit('click-quotation', this.phoneNumber)
      }
    }
  }
}
</script>
<template>
  <div class="homepage_quotation_container">
    <h2 class="pc_owner_h2">
      <strong>{{ title }}</strong>
    </h2>
    <el-input
      v-model="phoneNumber"
      maxlength="11"
      placeholder="请输入你的手机号"
      oninput="value=value.replace(/[^\d]/g,'')"
      style="margin-bottom:20px;width:100%;"
    ></el-input>
    <div @click="onClickQuotation" class="default_button quotation_button">
      <strong>{{ buttonText }}</strong>
    </div>
  </div>
</template>
<style lang="scss">
.homepage_quotation_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  > h2 {
    margin-bottom: 21px;
    font-size: 18px;
    strong {
      font-weight: 500 !important;
    }
  }
  .quotation_button {
    width: 100%;
    min-width: 128px;
    height: 38px;
  }
}
</style>
